var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{ref:"chart",attrs:{"type":"bar","height":"370","options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }